var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('challenges-situations-template',{attrs:{"challenges":_vm.challengesFiltered,"loading":_vm.loading},on:{"scroll-in-bottom":function($event){return _vm.inBottom()}},scopedSlots:_vm._u([{key:"empty-msg",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.emptyMessage)+"\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }